// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "LocationsListItem-module--wrapper--wsNJb";
export var title = "LocationsListItem-module--title--fze4m";
export var description = "LocationsListItem-module--description--ZocOb";